import { ConfigService, SpeJFundsProxy, SpeViewNDashboardClientProxy, SpeJCashInProxy, SpeJCheckEventProxy, SpeNBilletProxy, SpeViewNBilletProxy, SpeViewNAccountProxy, SpeNImportationBilletProxy, SpeNConsignedCalculatorProxy, SpeViewNAccountConsigned, SpeNAccountProxy, SpeNAccountsProxy, SpeNFGTSProxy, SpeViewNFGTSProxy, UiPxCashInModule } from '@wlp/ui-px-cashin';
export { CancelBilletRequestDto, ImmediateDischargeBilletRequestDto } from '@wlp/ui-px-cashin';
import { __decorate, __metadata, __awaiter, __param } from 'tslib';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { BaseService, ErrorMessageService, DocumentValidator, DateValidator, IpService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { BehaviorSubject } from 'rxjs';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

class AccountBalanceResponse {
}

class AccountPaymentRechargeBilletResponse {
}

class AccountPaymentLotBilletDto {
    constructor(uuidAccountPayment, uuidWhiteLabel, name, description, status) {
        this.uuidAccountPayment = uuidAccountPayment;
        this.uuidWhiteLabel = uuidWhiteLabel;
        this.name = name;
        this.description = description;
        this.status = status;
    }
}

class UpdateBilletResponseDto {
}
class UpdateBilletDetailResponseDto {
}
class UpdateBilletInputResponseDto {
}
class EmitBilletResponse extends UpdateBilletResponseDto {
}
class EmitLotRequestDto {
}
class EmitLotBilletResponseDto {
}
class EmitLotResponseDto {
}

class AccountShareResponse {
}

class CreateLotRequestDto {
}
class CreateRechargeRequestDto {
}
class BilletPayerRequestDTO {
}
class BilletFeeRequestDto {
}
class BilletFineRequestDto {
}
class BilletDiscountRequestDto {
}
class BilletDiscountDetailsRequestDto {
}
class BilletProtestRequestDto {
}
class BilletInstructionRequestDto {
}
class BilletPayerAddressRequestDto {
}

class NotificationsResponse {
}

class RechargeBilletResponse {
}

var BilletDiscountTypeEnum;
(function (BilletDiscountTypeEnum) {
    BilletDiscountTypeEnum["NOT_DISCOUNT"] = "NOT_DISCOUNT";
    BilletDiscountTypeEnum["FIXED_DISCOUNT"] = "FIXED_DISCOUNT";
    BilletDiscountTypeEnum["PROPORTIONAL_DISCOUNT"] = "PROPORTIONAL_DISCOUNT";
    BilletDiscountTypeEnum["PROPORTIONAL_IN_ADVANCE_DISCOUNT"] = "PROPORTIONAL_IN_ADVANCE_DISCOUNT";
    BilletDiscountTypeEnum["FIXED_IN_ADVANCE_DISCOUNT"] = "FIXED_IN_ADVANCE_DISCOUNT";
})(BilletDiscountTypeEnum || (BilletDiscountTypeEnum = {}));

var BilletInterestTypeEnum;
(function (BilletInterestTypeEnum) {
    BilletInterestTypeEnum["PROPORTIONAL_INTEREST"] = "PROPORTIONAL_INTEREST";
    BilletInterestTypeEnum["DAYS_INTEREST"] = "DAYS_INTEREST";
})(BilletInterestTypeEnum || (BilletInterestTypeEnum = {}));

var BilletProtestTypeEnum;
(function (BilletProtestTypeEnum) {
    BilletProtestTypeEnum["EFFECTIVE_PROTEST"] = "EFFECTIVE_PROTEST";
    BilletProtestTypeEnum["NOT_PROTEST"] = "NOT_PROTEST";
    BilletProtestTypeEnum["CANCEL_PROTEST"] = "CANCEL_PROTEST";
})(BilletProtestTypeEnum || (BilletProtestTypeEnum = {}));

var BilletSpecieTypeEnum;
(function (BilletSpecieTypeEnum) {
    BilletSpecieTypeEnum["DM"] = "DM";
    BilletSpecieTypeEnum["NP"] = "NP";
    BilletSpecieTypeEnum["NS"] = "NS";
    BilletSpecieTypeEnum["ME"] = "ME";
    BilletSpecieTypeEnum["RC"] = "RC";
    BilletSpecieTypeEnum["CT"] = "CT";
    BilletSpecieTypeEnum["DS"] = "DS";
    BilletSpecieTypeEnum["LC"] = "LC";
    BilletSpecieTypeEnum["DD"] = "DD";
    BilletSpecieTypeEnum["EC"] = "EC";
    BilletSpecieTypeEnum["FS"] = "FS";
    BilletSpecieTypeEnum["BDP"] = "BDP";
    BilletSpecieTypeEnum["BDA"] = "BDA";
    BilletSpecieTypeEnum["CBI"] = "CBI";
    BilletSpecieTypeEnum["CC"] = "CC";
    BilletSpecieTypeEnum["CCB"] = "CCB";
    BilletSpecieTypeEnum["CD"] = "CD";
    BilletSpecieTypeEnum["CH"] = "CH";
    BilletSpecieTypeEnum["CM"] = "CM";
    BilletSpecieTypeEnum["CPS"] = "CPS";
    BilletSpecieTypeEnum["DMI"] = "DMI";
    BilletSpecieTypeEnum["DSI"] = "DSI";
    BilletSpecieTypeEnum["RA"] = "RA";
    BilletSpecieTypeEnum["TA"] = "TA";
    BilletSpecieTypeEnum["DV"] = "DV";
})(BilletSpecieTypeEnum || (BilletSpecieTypeEnum = {}));

var BilletStatusEnum;
(function (BilletStatusEnum) {
    BilletStatusEnum["PENDING"] = "PENDING";
    BilletStatusEnum["COMPENSATED"] = "COMPENSATED";
    BilletStatusEnum["PAID"] = "PAID";
    BilletStatusEnum["ERROR"] = "ERROR";
    BilletStatusEnum["LIMIT_OPERATION"] = "LIMIT_OPERATION";
    BilletStatusEnum["MANUAL_COMPENSATION"] = "MANUAL_COMPENSATION";
    BilletStatusEnum["DRAFT"] = "DRAFT";
    BilletStatusEnum["CANCELED"] = "CANCELED";
    BilletStatusEnum["OVERDUE"] = "OVERDUE";
})(BilletStatusEnum || (BilletStatusEnum = {}));

var BilletTrafficTicketTypeEnum;
(function (BilletTrafficTicketTypeEnum) {
    BilletTrafficTicketTypeEnum["FIXED_TICKET"] = "FIXED_TICKET";
    BilletTrafficTicketTypeEnum["PROPORTIONAL_TICKET"] = "PROPORTIONAL_TICKET";
    BilletTrafficTicketTypeEnum["FREE_TICKET"] = "FREE_TICKET";
})(BilletTrafficTicketTypeEnum || (BilletTrafficTicketTypeEnum = {}));

var BilletTypeEnum;
(function (BilletTypeEnum) {
    BilletTypeEnum["RECHARGE"] = "RECHARGE";
    BilletTypeEnum["CHARGING"] = "CHARGING";
})(BilletTypeEnum || (BilletTypeEnum = {}));

var LotStatusEnum;
(function (LotStatusEnum) {
    LotStatusEnum["PENDING"] = "PENDING";
    LotStatusEnum["AVAILABLE"] = "AVAILABLE";
    LotStatusEnum["IN_VALIDATION"] = "IN_VALIDATION";
    LotStatusEnum["IN_PROCESS"] = "IN_PROCESS";
    LotStatusEnum["IN_PROCESS_ERROR"] = "IN_PROCESS_ERROR";
    LotStatusEnum["DRAFT"] = "DRAFT";
    LotStatusEnum["CANCELED"] = "CANCELED";
})(LotStatusEnum || (LotStatusEnum = {}));

let AccountBalanceService = class AccountBalanceService extends BaseService {
    constructor(storage, configService, speJFundsProxy, speViewNDashboardClientProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speJFundsProxy = speJFundsProxy;
        this.speViewNDashboardClientProxy = speViewNDashboardClientProxy;
        this.errorMessageService = errorMessageService;
        this.balance$ = new BehaviorSubject('');
    }
    getBalance(idWhiteLabel, uuidAccountPayment) {
        return this.speJFundsProxy.getCheckBalance(idWhiteLabel, uuidAccountPayment).toPromise();
    }
    getCashback(uuidAccountPayment) {
        return this.speViewNDashboardClientProxy.getCashback(uuidAccountPayment);
    }
    getBalanceSubject() {
        return this.balance$;
    }
    setBalanceSubject(data) {
        this.balance$.next(data);
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    getBalanceCashback(uuidWhilabel, uuidAccountPayment) {
        return this.speJFundsProxy.getBalanceCashback(uuidWhilabel, uuidAccountPayment);
    }
};
AccountBalanceService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeJFundsProxy,
        SpeViewNDashboardClientProxy,
        ErrorMessageService])
], AccountBalanceService);

let AccountRechargeService = class AccountRechargeService {
    constructor(errorMessageService, formBuilder, speJCashInProxy, speJCheckEventProxy) {
        this.errorMessageService = errorMessageService;
        this.formBuilder = formBuilder;
        this.speJCashInProxy = speJCashInProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.behaviourRecharge = new BehaviorSubject(null);
        this.errorMessages = {
            valueField: [
                { type: 'required', message: 'CASH_IN.ACCOUNT_RECHARGE.FORM.VALUE_FIELD.MESSAGE.REQUIRED' },
                {
                    type: 'min',
                    message: 'CASH_IN.ACCOUNT_RECHARGE.FORM.VALUE_FIELD.MESSAGE.MIN',
                    param: { min: 20 },
                },
            ],
        };
    }
    getErrorAccountRecharge(error) {
        this.errorMessageService.getError(error);
    }
    getFormErrorMessage() {
        return this.errorMessages;
    }
    saveValue(data) {
        this.behaviourRecharge.next(data);
    }
    getValue() {
        return this.behaviourRecharge;
    }
    unSubscribe() {
        this.behaviourRecharge = new BehaviorSubject(null);
    }
    getRechargeData() {
        this.formRecharge = this.formBuilder.group({
            valueField: new FormControl('', Validators.compose([Validators.required, Validators.min(20)])),
        });
        return this.formRecharge;
    }
    generateBillet(value, uuidAccountPaymet, uuidWhitelabel) {
        return this.speJCashInProxy.generateBillet(value, uuidAccountPaymet, uuidWhitelabel);
    }
    getBilletsByUuidAccountPayment(uuidAccountPayment) {
        return this.speJCashInProxy.getBilletsByUuidAccountPayment(uuidAccountPayment);
    }
    getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type);
    }
    getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd);
    }
    getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, dateInitial, dateEnd);
    }
    getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd);
    }
    getBilletsByUuid(uuid) {
        return this.speJCashInProxy.getBilletsByUuid(uuid);
    }
    getBilletsByTransactionId(transactionId) {
        return this.speJCashInProxy.getBilletsByTransactionId(transactionId);
    }
    validateOperation(uuidWhiteLabel, uuidAccount, valueBillet) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            sendingBody = {
                codeOperation: '1001',
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: parseFloat(valueBillet),
            };
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getErrorAccountRecharge(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
};
AccountRechargeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ErrorMessageService,
        FormBuilder,
        SpeJCashInProxy,
        SpeJCheckEventProxy])
], AccountRechargeService);

let AccountShareService = class AccountShareService {
    constructor() {
    }
};
AccountShareService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], AccountShareService);

let BilletLotService = class BilletLotService {
    constructor(speNBilletProxy, speViewNBilletProxy) {
        this.speNBilletProxy = speNBilletProxy;
        this.speViewNBilletProxy = speViewNBilletProxy;
    }
    createLot(createLotRequestDto) {
        return this.speNBilletProxy.createLot(createLotRequestDto);
    }
    updateValue(uuidBillet, body) {
        return this.speNBilletProxy.updateValue(uuidBillet, body);
    }
    updateDueDate(uuidBillet, body) {
        return this.speNBilletProxy.updateDueDate(uuidBillet, body);
    }
    updateLimitDate(uuidBillet, body) {
        return this.speNBilletProxy.updateLimitDate(uuidBillet, body);
    }
    updateFees(uuidBillet, body) {
        return this.speNBilletProxy.updateFees(uuidBillet, body);
    }
    updateFine(uuidBillet, body) {
        return this.speNBilletProxy.updateFine(uuidBillet, body);
    }
    updateDiscount(uuidBillet, body) {
        return this.speNBilletProxy.updateDiscount(uuidBillet, body);
    }
    updateRequestNumber(uuidBillet, body) {
        return this.speNBilletProxy.updateRequestNumber(uuidBillet, body);
    }
    updateProtest(uuidBillet, body) {
        return this.speNBilletProxy.updateProtest(uuidBillet, body);
    }
    updatePayer(uuidBillet, body) {
        return this.speNBilletProxy.updatePayer(uuidBillet, body);
    }
    updateAbatement(uuidBillet, body) {
        return this.speNBilletProxy.updateAbatement(uuidBillet, body);
    }
    emitLot(data) {
        return this.speNBilletProxy.emitLot(data);
    }
    cancelBillet(body) {
        return this.speNBilletProxy.cancelBillet(body);
    }
    cancelBilletLot(body) {
        return this.speNBilletProxy.cancelBilletLot(body);
    }
    getLotsByAccountPayment(uuidAccountPayment) {
        return this.speViewNBilletProxy.getLotsByAccountPayment(uuidAccountPayment);
    }
    getLotWithBilletsByLotUuid(uuidAccountPayment, uuidLot) {
        return this.speViewNBilletProxy.getLotWithBilletsByLotUuid(uuidAccountPayment, uuidLot);
    }
    getLots(startDate, endDate, status, searchText) {
        return this.speViewNBilletProxy.getLots(startDate, endDate, status, searchText);
    }
    getLotsPaginated(startDate, endDate, status, searchText, paginationParams) {
        return this.speViewNBilletProxy.getLotsPaginated(startDate, endDate, status, searchText, paginationParams);
    }
};
BilletLotService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNBilletProxy,
        SpeViewNBilletProxy])
], BilletLotService);

let BilletService = class BilletService {
    constructor(speJCashInProxy, speJCheckEventProxy, speViewNAccountProxy, speNImportationBilletProxy, speViewNBilletProxy, errorMessageService, speNBilletProxy) {
        this.speJCashInProxy = speJCashInProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speNImportationBilletProxy = speNImportationBilletProxy;
        this.speViewNBilletProxy = speViewNBilletProxy;
        this.errorMessageService = errorMessageService;
        this.speNBilletProxy = speNBilletProxy;
        this.behaviourBillet = new BehaviorSubject(null);
    }
    saveValue(data) {
        this.behaviourBillet.next(data);
    }
    getValue() {
        return this.behaviourBillet;
    }
    unSubscribe() {
        this.behaviourBillet = new BehaviorSubject(null);
    }
    generateBillet(body) {
        return this.speJCashInProxy.generateBilletWithObject(body);
    }
    getBilletsByUuidAccountPayment(uuidAccountPayment, type) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type);
    }
    getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd);
    }
    getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, type, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd);
    }
    getBilletsByUuid(uuid) {
        return this.speJCashInProxy.getBilletsByUuid(uuid);
    }
    getAllStatusDataByStatus(uuidAccountPayment, type, status, dateInitial, dateEnd) {
        return this.speJCashInProxy.getAllStatusDataByStatus(uuidAccountPayment, type, status, dateInitial, dateEnd);
    }
    getAllStatusDataByUuidAccountPaymentLotBillet(uuidAccountPayment, uuidAccountPaymentLotBillet, type, status) {
        return this.speJCashInProxy.getAllStatusDataByUuidAccountPaymentLotBillet(uuidAccountPayment, uuidAccountPaymentLotBillet, type, status);
    }
    getBilletsByTransactionId(transactionId) {
        return this.speJCashInProxy.getBilletsByTransactionId(transactionId);
    }
    getBilletCreateTax(uuidWhiteLabel, uuidAccountPayment, codeOperation) {
        return __awaiter(this, void 0, void 0, function* () {
            let taxResponse;
            yield this.speViewNAccountProxy
                .getCardTax(uuidWhiteLabel, uuidAccountPayment, codeOperation)
                .toPromise()
                .then((res) => {
                taxResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!taxResponse ? taxResponse : null;
            return Promise.resolve(response);
        });
    }
    validateOperation(uuidWhiteLabel, uuidAccount, valueBillet) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            sendingBody = {
                codeOperation: '1002',
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: this.formatValue(valueBillet),
            };
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => console.error(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let billetValue = value.replace(/\./g, '');
        let billetValue2 = billetValue.replace(',', '.');
        return parseFloat(billetValue2);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    // Tipar os objetos de retorno após a criação dos serviços
    getLotBillets(uuidAccount) {
        return this.speViewNBilletProxy.getLotBillets(uuidAccount);
    }
    // Tipar os objetos de retorno após a criação dos serviços
    getLot(uuidLot) {
        return this.speViewNBilletProxy.getLot(uuidLot);
    }
    getBilletDownload(transactionId) {
        return this.speJCashInProxy.getBilletDownload(transactionId);
    }
    getBilletDownloadLot(uuidLot) {
        return this.speJCashInProxy.getBilletDownloadLot(uuidLot);
    }
    /**
     * @description Dados Moc no aguardo do serviço, alterar quando o mesmo estiver pronto !
     */
    getLotListBillets(uuidAccountPayment, uuidAccountPaymentLotBillet) {
        return this.speViewNBilletProxy.getListBilletsLot(uuidAccountPayment, uuidAccountPaymentLotBillet);
    }
    getChargingBillets(startDate, endDate, status, searchText) {
        return this.speViewNBilletProxy.getChargingBillets(startDate, endDate, status, searchText);
    }
    getChargingBilletsPaginated(startDate, endDate, status, searchText, paginationParams) {
        return this.speViewNBilletProxy.getChargingBilletsPaginated(startDate, endDate, status, searchText, paginationParams);
    }
    removeLotBillets(uuidLot) {
        return this.speViewNBilletProxy.removeLotBillets(uuidLot);
    }
    postbatchBillsModel$(body, uuidWhiteLabel) {
        return this.speNImportationBilletProxy.postbatchBillsModel$(body, uuidWhiteLabel);
    }
    getbatchBillsModel$(format) {
        return this.speNImportationBilletProxy.batchBillsModel$(format);
    }
    confirmLotBillet(uuidLotBillet, authorizationCode) {
        return this.speNImportationBilletProxy.confirmLotBillet(uuidLotBillet, authorizationCode);
    }
    findByUuidBilletV2(uuidBillet) {
        return this.speViewNBilletProxy.findByUuidBilletV2(uuidBillet);
    }
    getExportXlsx(startDate, endDate, status, searchText) {
        return this.speViewNBilletProxy.getExportXlsx(startDate, endDate, status, searchText);
    }
    cancelBillet(body) {
        return this.speNBilletProxy.cancelBillet(body);
    }
    immediateDischargeBillet(body) {
        return this.speNBilletProxy.immediateDischarge(body);
    }
};
BilletService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeJCashInProxy,
        SpeJCheckEventProxy,
        SpeViewNAccountProxy,
        SpeNImportationBilletProxy,
        SpeViewNBilletProxy,
        ErrorMessageService,
        SpeNBilletProxy])
], BilletService);

let ChargingService = class ChargingService extends BaseService {
    constructor(storage, configService, formBuilder) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.formBuilder = formBuilder;
        /**
         * @description ATUALIZADO!
         */
        this.errorMessages = {
            document: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
                {
                    type: 'cnpjNotValid',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.CNPJ_NOT_VALID',
                },
                {
                    type: 'cpfNotValid',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.CPF_NOT_VALID',
                },
            ],
            nameComplete: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
            ],
            email: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            billetValue: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
                {
                    type: 'min',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MIN',
                    param: { min: 20 },
                },
            ],
            descripiton: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
            ],
            dateDue: [
                { type: 'required', message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED' },
                {
                    type: 'validDateAfter',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.DATE_NOT_VALID_AFTER',
                    param: { dateAfter: 3 },
                },
                {
                    type: 'ptDate',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.DATE_NOT_VALID',
                },
            ],
            billetBodyObservations: [
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 120,
                    },
                },
            ],
            orderNumber: [
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 20,
                    },
                },
            ],
        };
    }
    createFormEmitBillet() {
        this.billetChargingForm = this.formBuilder.group({
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            nameComplete: new FormControl('', Validators.compose([Validators.required])),
            billetValue: new FormControl('', Validators.compose([Validators.required])),
            descripiton: new FormControl('', Validators.compose([Validators.maxLength(200)])),
            billetBodyObservations: new FormControl('', Validators.compose([Validators.maxLength(120)])),
            orderNumber: new FormControl('', Validators.compose([Validators.maxLength(20), Validators.pattern('^[A-Za-z0-9-]*$')])),
            dateDue: new FormControl('', Validators.compose([Validators.required, DateValidator.validDateAfter, DateValidator.ptDate])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
        });
        return this.billetChargingForm;
    }
    disabledToogle(billetChargingForm) {
        return billetChargingForm.controls.document.valid && billetChargingForm.controls.name.valid;
    }
    getErrorMessages() {
        return this.errorMessages;
    }
};
ChargingService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage, ConfigService, FormBuilder])
], ChargingService);

let ConsignedService = class ConsignedService {
    constructor(speNConsignedCalculatorProxy, speViewNAccountConsigned, ipService, htttp) {
        this.speNConsignedCalculatorProxy = speNConsignedCalculatorProxy;
        this.speViewNAccountConsigned = speViewNAccountConsigned;
        this.ipService = ipService;
        this.htttp = htttp;
    }
    newSimulation(uuid, value, hasInsurance, uuidWhiteLabel) {
        return this.speNConsignedCalculatorProxy.createSimulation(uuid, value, hasInsurance, uuidWhiteLabel);
    }
    requestProposal(id, installmentNumber, tokenClient, isNonStandard, device, latitude, longitude, uuidWhiteLabel) {
        let body = {
            tokenClient,
            isNonStandard,
            device,
            latitude,
            longitude,
            uuidWhiteLabel
        };
        return this.speNConsignedCalculatorProxy.requestProposal(id, installmentNumber, body);
    }
    getPreApproved(uuid) {
        return this.speNConsignedCalculatorProxy.getPreApproved(uuid);
    }
    findAllSimulationsSpecialByUuidCustomer() {
        return this.speViewNAccountConsigned.findAllSimulationsSpecialByUuidCustomer();
    }
    getSimulation() {
        return this.speViewNAccountConsigned.getSimulation();
    }
    findUuidAccountPaymentLastProposalPendingSign() {
        return this.speViewNAccountConsigned.findUuidAccountPaymentLastProposalPendingSign();
    }
    getProposal() {
        return this.speViewNAccountConsigned.getProposal();
    }
    getContract() {
        return this.speViewNAccountConsigned.getContracts();
    }
    getAprovationHistory(uuidProposal) {
        return this.speViewNAccountConsigned.getAprovationHistory(uuidProposal);
    }
    prepareStatus(proposal, approvedHistory) {
        /* Cria historico para solicitado */
        let arrayAproved = [
            {
                dateUpdate: proposal.dateRegister,
                status: "REQUESTED_PROPOSAL"
            }
        ];
        return arrayAproved.concat(approvedHistory);
    }
    moutTextStatus(arrayAproved) {
        /* let isAproved: number = 0; */
        return arrayAproved.map(el => {
            if (el.status === "REQUESTED_PROPOSAL") {
                el.nameStatus = "Solicitado";
                return el;
            }
            if (el.status === "REQUESTED") {
                el.nameStatus = "Em análise";
                return el;
            }
            if (el.status === "CONTRACT_WORK_SIGNATURE") {
                el.nameStatus = "Aprovado";
                return el;
            }
        });
    }
    getContractProspol(uuidWhiteLabel, installmentsNumber, idSimulation) {
        return this.speViewNAccountConsigned.getContractProsposal(uuidWhiteLabel, installmentsNumber, idSimulation);
    }
    getContractTerms(uuid) {
        return this.speViewNAccountConsigned.getContractTerms(uuid);
    }
    getCCB(uuidProposal) {
        return this.speViewNAccountConsigned.getCCB(uuidProposal);
    }
    signProposal(data) {
        let dateNow = new Date().toLocaleDateString().split("/");
        data.signatures[0].signatureDate = `${dateNow[2]}-${dateNow[1]}-${dateNow[0]}T14:25:38.588Z`;
        return this.speNConsignedCalculatorProxy.signProsposal(data);
    }
};
ConsignedService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNConsignedCalculatorProxy,
        SpeViewNAccountConsigned,
        IpService,
        HttpClient])
], ConsignedService);

let NotificationsService = class NotificationsService extends BaseService {
    constructor(speNAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speNAccountProxy = speNAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.notificationTemplates = [
            {
                type: 1,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.TED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.TED.MESSAGE"
            },
            {
                type: 2,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.ON_US.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.ON_US.MESSAGE"
            },
            {
                type: 3,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.NEW_DEVICE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.NEW_DEVICE.MESSAGE"
            },
            {
                type: 4,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_DEVICE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_DEVICE.MESSAGE"
            },
            {
                type: 5,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_EMAIL.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_EMAIL.MESSAGE"
            },
            {
                type: 6,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_FEE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_FEE.MESSAGE"
            },
            {
                type: 7,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_ISSUED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_ISSUED.MESSAGE"
            },
            {
                type: 8,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_PAYED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_PAYED.MESSAGE"
            },
            {
                type: 9,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_ISSUED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_ISSUED.MESSAGE"
            },
            {
                type: 10,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_PAYED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_PAYED.MESSAGE"
            },
            {
                type: 11,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.SALES_CREDIT.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.SALES_CREDIT.MESSAGE"
            },
            {
                type: 12,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.MOBILE_RECHARGE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.MOBILE_RECHARGE.MESSAGE"
            },
            {
                type: 13,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_ISSUE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_ISSUE.MESSAGE"
            }
        ];
        this.loadKey();
    }
    getTemplateByType(data) {
        return this.notificationTemplates.find((template) => {
            return template.type === data.type;
        });
    }
    getMappedNotification(data) {
        const template = this.getTemplateByType.call(this, data);
        return ({
            template,
            params: Object.assign({}, data),
            date: data.date
        });
    }
    mapNotificationDataToTemplate(notificationData) {
        if (Array.isArray(notificationData)) {
            return notificationData.map(this.getMappedNotification.bind(this));
        }
        return this.getMappedNotification.call(this, notificationData);
    }
    getNotificationData(uuidAccount) {
        return this.speNAccountProxy.getNotificationData(uuidAccount);
    }
    getNotification(uuidAccount) {
        let notifications = this.speNAccountProxy.getNotifications(uuidAccount);
        /*     this.speNAccountProxy
              .getNotifications(this.keyPreAccount)
              .subscribe(
                data => {
                  notifications = data;
                },
                err => this.errorMessageService.getError(err)
              ); */
        return notifications;
    }
    confirmReading(notification, uuidAccount) {
        const notifications = this.prepareNotification(notification);
        return this.speNAccountProxy.confirmReading(uuidAccount, notifications);
    }
    prepareNotification(notification) {
        notification = [
            {
                "title": "Confirmação de TED",
                "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries",
                "date": "2020-06-02T16:29:26.809Z",
                "read": true
            },
            {
                "title": "Confirmação de Pagamento",
                "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries",
                "date": "2020-06-02T16:29:26.809Z",
                "read": true
            }
        ];
        return notification;
    }
};
NotificationsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], NotificationsService);

let QrcodeOnusService = class QrcodeOnusService extends BaseService {
    constructor(storage, configService, formBuilder, speNAccountsProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.formBuilder = formBuilder;
        this.speNAccountsProxy = speNAccountsProxy;
    }
    getFormMessageError() {
        return {
            value: [
                { type: 'required', message: 'QRCODE_ON_US.INTRO.INPUT.ERROR' },
            ]
        };
    }
    createFormTransfer() {
        return this.formBuilder.group({
            value: new FormControl('', Validators.compose([
                Validators.required,
            ]))
        });
    }
    generateQrcode(uuidAccountPayment, value) {
        return this.speNAccountsProxy.generateQrcode(uuidAccountPayment, Number(value.replaceAll('.', '').replace(',', '.')));
    }
    statusQrcode(encode) {
        return this.speNAccountsProxy.statusQrcode(encode);
    }
};
QrcodeOnusService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        FormBuilder,
        SpeNAccountsProxy])
], QrcodeOnusService);

let StatementService = class StatementService {
    constructor(speJFundsProxy, errorMessageService) {
        this.speJFundsProxy = speJFundsProxy;
        this.errorMessageService = errorMessageService;
    }
    getLatestTransaction(idWhiteLabel, uuidAccount, quantityItens) {
        return this.speJFundsProxy
            .getLatestTransaction(idWhiteLabel, uuidAccount, quantityItens)
            .toPromise();
    }
    getSumMoviments(idWhiteLabel, uuidAccount) {
        return this.speJFundsProxy
            .getSumMoviments(idWhiteLabel, uuidAccount, this.startDate(), this.endDate())
            .toPromise();
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    startDate() {
        let date = new Date(), dayF = '01', month = (date.getMonth() + 1).toString(), monthF = (month.length == 1) ? '0' + month : month, yearF = date.getFullYear();
        return yearF + '-' + monthF + '-' + dayF;
    }
    endDate() {
        let date = new Date(), day = date.getDate().toString(), dayF = (day.length == 1) ? '0' + day : day, month = (date.getMonth() + 1).toString(), monthF = (month.length == 1) ? '0' + month : month, yearF = date.getFullYear();
        return yearF + '-' + monthF + '-' + dayF;
    }
};
StatementService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeJFundsProxy,
        ErrorMessageService])
], StatementService);

let FgtsService = class FgtsService {
    constructor(speNFGTSProxy, speViewNFGTSProxy, ipService, htttp) {
        this.speNFGTSProxy = speNFGTSProxy;
        this.speViewNFGTSProxy = speViewNFGTSProxy;
        this.ipService = ipService;
        this.htttp = htttp;
    }
    newSimulation(valueSimulation) {
        return this.speNFGTSProxy.simulation(valueSimulation);
    }
    customAmountSimulation(valueSimulation) {
        return this.speNFGTSProxy.customAmountSimulation(valueSimulation);
    }
    requestProposal(uuidSimulation, tokenClient, device, latitude, longitude, uuidWhiteLabel) {
        let body = {
            uuidSimulation,
            tokenClient,
            device,
            latitude,
            longitude,
            uuidWhiteLabel
        };
        return this.speNFGTSProxy.requestProposal(body);
    }
    prepareStatus(proposal, approvedHistory) {
        /* Cria historico para solicitado */
        let arrayAproved = [
            {
                dateUpdate: proposal.dateRegister,
                status: "REQUESTED_PROPOSAL"
            }
        ];
        return arrayAproved.concat(approvedHistory);
    }
    /*  getContractProspol(uuidWhiteLabel: string, installmentsNumber: string, idSimulation: string) {
         return this.speViewNFGTSProxy.getContractProsposal(uuidWhiteLabel, installmentsNumber, idSimulation);
     }
 
     getContractTerms(uuid: string): Observable<any> {
         return this.speViewNFGTSProxy.getContractTerms(uuid);
     }
     */
    signProposal(data) {
        /* let dateNow = new Date().toLocaleDateString().split("/");
        data.signatures[0].signatureDate = `${dateNow[2]}-${dateNow[1]}-${dateNow[0]}T14:25:38.588Z`; */
        return this.speNFGTSProxy.signProsposal(data);
    }
    getCCB(uuidProposal) {
        return this.speViewNFGTSProxy.getCCB(uuidProposal);
    }
    getSimulations() {
        return this.speViewNFGTSProxy.getSimulations();
    }
    getAllProposalsRequested() {
        return this.speViewNFGTSProxy.getAllProposalsRequested();
    }
    getPaymentDataCancelProposal(uuidProposal) {
        return this.speViewNFGTSProxy.getPaymentDataCancelProposal(uuidProposal);
    }
    aprovationHistory(uuidProposal) {
        return this.speViewNFGTSProxy.aprovationHistory(uuidProposal);
    }
    getAllContracts() {
        return this.speViewNFGTSProxy.getAllContracts();
    }
    cancelProposal(body) {
        return this.speNFGTSProxy.cancelProposal(body);
    }
    mapperProposal(proposal) {
        return {
            "uuid": proposal.uuid,
            "type": proposal.type,
            "cpf": proposal.cpf,
            "proposalCode": proposal.proposalCode,
            "dateUpdated": proposal.dateUpdate,
            "maxPeriod": proposal.maxPeriod,
            "minPeriod": proposal.minPeriod,
            "withdrawalAmount": proposal.withdrawalAmount,
            "uuidProposal": proposal.uuidProposal,
            "simulation": {
                "additionalIofAmount": proposal.proposal.additionalIofAmount,
                "amortizationAmount": proposal.proposal.amortizationAmount,
                "annualCETRate": proposal.proposal.annualCETRate,
                "annualInterestRate": proposal.proposal.annualInterestRate,
                "balance": proposal.proposal.balance,
                "ccbRate": proposal.proposal.ccbRate,
                "customerLoanAmount": proposal.proposal.customerLoanAmount,
                "endDate": proposal.proposal.endDate,
                "insuranceAmount": proposal.proposal.insuranceAmount,
                "interestAmount": proposal.proposal.interestAmount,
                "iofAmount": proposal.proposal.iofAmount,
                "monthlyCETRate": proposal.proposal.monthlyCETRate,
                "monthlyRate": proposal.proposal.monthlyRate,
                "operationAmount": proposal.proposal.operationAmount,
                "period": proposal.proposal.period,
                "releasedAmount": proposal.proposal.releasedAmount,
                "reserveAmount": proposal.proposal.reserveAmount,
                "startDate": proposal.proposal.startDate,
                "tacAmount": proposal.proposal.tacAmount,
                "transferAmount": proposal.proposal.transferAmount,
                "simulationInstallments": proposal.proposal.proposalInstallments,
                "isCancellationValid": proposal.proposal.isCancellationValid,
            }
        };
    }
};
FgtsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNFGTSProxy,
        SpeViewNFGTSProxy,
        IpService,
        HttpClient])
], FgtsService);

var UiBsCashInModule_1;
let UiBsCashInModule = UiBsCashInModule_1 = class UiBsCashInModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsCashInModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsCashInModule = UiBsCashInModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxCashInModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            AccountBalanceService,
            NotificationsService,
            AccountRechargeService,
            StatementService,
            BilletService,
            ChargingService,
            QrcodeOnusService,
            ConsignedService,
            BilletLotService,
            FgtsService
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsCashInModule])
], UiBsCashInModule);

export { AccountBalanceResponse, AccountBalanceService, AccountPaymentLotBilletDto, AccountPaymentRechargeBilletResponse, AccountRechargeService, AccountShareResponse, AccountShareService, BilletDiscountDetailsRequestDto, BilletDiscountRequestDto, BilletDiscountTypeEnum, BilletFeeRequestDto, BilletFineRequestDto, BilletInstructionRequestDto, BilletInterestTypeEnum, BilletLotService, BilletPayerAddressRequestDto, BilletPayerRequestDTO, BilletProtestRequestDto, BilletProtestTypeEnum, BilletService, BilletSpecieTypeEnum, BilletStatusEnum, BilletTrafficTicketTypeEnum, BilletTypeEnum, ChargingService, ConsignedService, CreateLotRequestDto, CreateRechargeRequestDto, EmitBilletResponse, EmitLotBilletResponseDto, EmitLotRequestDto, EmitLotResponseDto, FgtsService, LotStatusEnum, NotificationsResponse, NotificationsService, QrcodeOnusService, RechargeBilletResponse, StatementService, UiBsCashInModule, UpdateBilletDetailResponseDto, UpdateBilletInputResponseDto, UpdateBilletResponseDto };
//# sourceMappingURL=wlp-ui-bs-cashin.js.map
